import { DoctorTrainingToolsItem } from '../interface/interface';
import { fetchTrainingTools } from '../service/fetchTrainingTools';
import { useQuery } from '@tanstack/react-query';

export function useToFetchTrainingTools(
  token: string,
  fetchResources: boolean = true,
): [Array<DoctorTrainingToolsItem>, boolean] {
  const { data, isFetching } = useQuery({
    queryKey: ['fetchTrainingTools', token, fetchResources],
    queryFn: async () => {
      const res = await fetchTrainingTools(token);

      if (typeof res === 'number') {
        console.log('Unable to fetch resources for doctors:', res);
        return;
      }

      return res;
    },
    enabled: !!token,
    initialData: [],
  });

  return [data, isFetching];
}
